module.exports = __webpack_public_path__ + "static/articles-f5a3b82a516df5508a76ec8e59768e28.jpg";